<mat-card-content>

    <div class="informacao cancelada">
        <h3>{{ "conclusao.inscricaoCancelada" | translate }}</h3>

        <p>{{ "conclusao.msg_inscricao_cancelada" | translate:{nome_aluno: nome, nome_curso: nome_curso} }}</p>

    </div>

</mat-card-content>
